// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1GIde","footer":"ModalCreateQualiphyProcedure_footer__2ao33","additionData":"ModalCreateQualiphyProcedure_additionData__vwXH3"};